import { useState } from "react";

export default function useRecharge(rechargeData) {
  // Boolean value used to facilatate recharge things
  const hasSubscription = !!rechargeData && rechargeData.selling_plans.length;

  // array of string values, ie: ['30 days', '60 days']
  const sellingPlans =
    rechargeData && rechargeData.selling_plans
      ? rechargeData.selling_plans.map(
          (i) => `${i.order_interval_frequency} ${i.order_interval_unit_type}s`
        )
      : [];

  // Find the selling plan Id based on the passed argument sellingPlan
  const getSellingPlanId = (sellingPlan) => {
    if (!hasSubscription || !rechargeData) {
      return null;
    }
    const lookFor = sellingPlan.split(" ")[0];
    const res = rechargeData.selling_plans
      .map((i) => {
        if (i.order_interval_frequency === parseInt(lookFor)) {
          return i.selling_plan_id;
        } else return null;
      })
      .filter(Boolean);
    if (res.length > 0) {
      return res[0];
    } else return null;
  };

  // Use a lineitem's custom attributes to return a string value of its subscription frequency
  const getFrequencyFromCustomAttributes = (customAttributes) => {
    const _subscriptionFrequency = customAttributes
      .map((i) => {
        if (i.key === "subscription_frequency") {
          return i.value;
        }
      })
      .filter(Boolean);
    const subscriptionFrequency =
      _subscriptionFrequency.length > 0 ? _subscriptionFrequency[0] : null;
    return subscriptionFrequency;
  };

  // Subscription Frequency string
  const [subscriptionFrequency, setSubscriptionFrequency] = useState(
    sellingPlans.length > 0 ? sellingPlans[0] : "0"
  );

  // Subscription Frequency int
  const [sellingPlanId, setSellingPlanId] = useState(
    getSellingPlanId(subscriptionFrequency)
  );

  //
  const handleSubscriptionChange = (arg) => {
    setSellingPlanId(getSellingPlanId(arg));
    setSubscriptionFrequency(arg);
  };

  // Data we pass along with the payload
  const recharge = {
    hasSubscription,
    sellingPlanId,
    subscriptionFrequency,
  };

  // purchaseFrequency options: [ once, subscription ]
  const [purchaseFrequency, setPurchaseFrequency] = useState("once");

  return {
    sellingPlans,
    hasSubscription,
    subscriptionFrequency,
    recharge,
    purchaseFrequency,
    getFrequencyFromCustomAttributes,
    handleSubscriptionChange,
    setPurchaseFrequency,
  };
}
